import { FANAL_TOGGLE_GRAPH_TABLE, FANAL_CHANGE_SELECTED_YEAR } from './constants'

export function fanalToggleGraphTable(module, id, blockKey, customData) {
    return {
        type: FANAL_TOGGLE_GRAPH_TABLE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function fanalChangeSelectedYear(module, id, blockKey, customData) {
    return {
        type: FANAL_CHANGE_SELECTED_YEAR,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}
